























// eslint-disable-next-line
import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

interface Post {
  title: string;
  body: string;
  author: { name: string };
  date: Date;
  lastUpdated: Date;
}

@Component
export default class BlogHome extends Vue {
  public posts: Post[] = [];
  public fetchError = "";

  private mounted(): void {
    this.refresh();
  }

  public formatDate(date: Date): string {
    return moment(date).format("MMM Do, YYYY");
  }

  public formatDateWithTime(date: Date): string {
    return moment(date).format("MMM Do, YYYY, h:mm A");
  }

  public formatLineBreaks(text: string): string {
    return text.replace(/\n/g, "<br>");
  }

  public getUserName(): string {
    return this.$store.state.currentUser.username;
  }

  public isAdmin(): boolean {
    return this.$store.state.currentUser.admin;
  }

  private async getPosts(): Promise<Post[]> {
    try {
      const response = await fetch(process.env.VUE_APP_API_URL + "/posts");
      const data = await response.json();
      return data.data;
    } catch (err) {
      console.error(err);
      return err.name;
    }
  }

  private refresh(): void {
    this.getPosts().then(ret => {
      this.posts = ret.sort((a: Post, b: Post) =>
        a.date > b.date ? -1 : a.date < b.date ? 1 : 0
      );
      this.fetchError = "";
    }).catch(err => {
      this.fetchError = err;
    });
  }

  public async deletePost(id: string): Promise<void> {
    if (confirm("Are you sure you want to delete this post?")) {
      try {
        const response = await fetch(
          process.env.VUE_APP_API_URL + "/posts/" + id,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.currentUserToken
            }
          }
        );
        if (response.status === 200) {
          this.refresh();
        }
      } catch (err) {
        console.error(err);
      }
    } else {
      return void 0;
    }
  }
}
